import { Injectable, signal } from '@angular/core';

/**
 * Counts SPICE backend HTTP requests currently in flight (see {@link httpGlobalErrorSnackInterceptor}).
 * Used as the app-wide signal that a page is waiting on an API (loader / blocking request).
 */
@Injectable({ providedIn: 'root' })
export class HttpFlightService {
  private _active = 0;
  readonly activeCount = signal(0);

  begin(): void {
    this._active += 1;
    this.activeCount.set(this._active);
  }

  end(): void {
    this._active = Math.max(0, this._active - 1);
    this.activeCount.set(this._active);
  }
}
